'use client'

import * as React from 'react'
import { cn } from '../../utils/cn'

interface SectionProps {
  children: React.ReactNode
  number?: string
  className?: string
  background?: 'default' | 'muted' | 'card'
  id?: string
  /** Add a subtle top border separator */
  divider?: boolean
}

const backgroundClasses = {
  default: '',
  muted: 'bg-[var(--landing-bg-muted)]',
  card: 'bg-[var(--landing-bg-card)]',
}

export function Section({
  children,
  number,
  className,
  background = 'default',
  id,
  divider = false
}: SectionProps) {
  return (
    <section
      id={id}
      className={cn(
        'landing-section relative',
        backgroundClasses[background],
        divider && 'border-t border-[rgba(255,255,255,0.05)]',
        className
      )}
    >
      {number && (
        <div className="landing-container mb-8">
          <span className="section-number">{number}</span>
        </div>
      )}
      {children}
    </section>
  )
}
